export const checkVariablesRegExp = /{{([^}]*)}}/gm
export const checkVariableRegExp = (variable:any) => {
    return `{{([^}]*)${variable}([^}]*)}}`
}

export const formatVariable = (variable:string) => {
    return `{{ ${variable} }}`
}
